export function _visibilityState(doc) {
  return doc.visibilityState;
}
